import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { AuthService } from './auth.service';
import { Router } from '@angular/router'

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  public constructor (
    public authService: AuthService,
    private router: Router,
  ) {}

  public intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(environment.API_URL || '/') && this.authService.storageAuthToken) {
      req = req.clone({
        withCredentials: true,
        setHeaders: {
          Authorization: `Bearer ${this.authService.storageAuthToken}`,
        },
      });
    }
    return next.handle(req).catch((err): Observable<HttpEvent<any>> => {
      if (!err || err.status !== 401) throw err;
      if (req.url.startsWith(`${environment.API_URL}/ws/mw/login`)) throw err;

      console.error('backend returned 401:Unauthorized error', err);
      this.authService.clearAuth();
      this.router.navigate(['/login'], {
        queryParams: {
          redirect: window.location.pathname,
        },
      });
      throw err;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth-http-interceptor.ts